import { action } from 'mobx'
import { AsyncPrompt } from '@/infra/AsyncPrompt'
import { ModalViewModel } from '@/infra/ModalViewModel'

/**
 * View model for the dialog that confirms reverting the draft to an older
 * version.
 */
export class RevertDialogViewModel {
  readonly modal = new ModalViewModel()

  private readonly _prompt = new AsyncPrompt<boolean>({
    abort$: this.modal.close$,
  })

  /**
   * Asks to confirm the revert.
   *
   * @returns Whether it was confirmed.
   */
  async prompt() {
    const response = this._prompt.prompt()
    this.modal.show()
    return (await response) ?? false
  }

  @action.bound
  confirm() {
    this._prompt.respond(true)
    this.modal.close()
  }

  @action.bound
  decline() {
    this._prompt.respond(false)
    this.modal.close()
  }
}
